import * as React from 'react';

import { ErrorLayout } from './ErrorLayout';
import image from '../assets/search.png';

interface ITripNotFoundErrorProps {
  onRequestAuth(): void;
  onBookClick(): void;
}

export const TripNotFoundError: React.FC<ITripNotFoundErrorProps> = ({ onRequestAuth, onBookClick }) => {
  return (
    <ErrorLayout
      image={image}
      title={
        <>
          Не&nbsp;нашли
          <br />
          ваши бронирования
        </>
      }
      description="Попробуйте сменить аккаунт или&nbsp;забронируйте поездку, чтобы&nbsp;оставить отзыв"
      actions={[
        { label: 'Сменить аккаунт', onClick: onRequestAuth, theme: 'fill_primary' },
        { label: 'Забронировать поездку', onClick: onBookClick, theme: 'fill_white_primary' },
      ]}
    />
  );
};
